export default "__VITE_ASSET__C6ADjr4___"